// Dependencies
import { graphql, useStaticQuery } from 'gatsby';

const useLocationsPostTypeFilteredWithoutChildren = () => {
  const { locations } = useStaticQuery(graphql`
    query Locations {
      locations: allWpLocation(
        sort: { title: ASC }
        filter: { locations: { displayInLocationsMap: { eq: true } } }
      ) {
        nodes {
          id
          uri
          title
          locations {
            displayInLocationsMap
            externalLink
            linkToParent
          }
          parentUri
        }
      }
    }
  `);

  return locations?.nodes;
};

export default useLocationsPostTypeFilteredWithoutChildren;
